// src/components/HeroCarousel.js

import React, { useState, useEffect } from "react";
import heroSlides from "../data/heroSlides";
import "../styles/HeroBanner.css";
import { ChevronLeft, ChevronRight } from "lucide-react";

console.log("Slides:", heroSlides);

const HeroCarousel = () => {
  const [current, setCurrent] = useState(0);

  const nextSlide = () => {
    setCurrent((prev) => (prev === heroSlides.length - 1 ? 0 : prev + 1));
  };

  const prevSlide = () => {
    setCurrent((prev) => (prev === 0 ? heroSlides.length - 1 : prev - 1));
  };

  useEffect(() => {
    const interval = setInterval(nextSlide, 8000); // auto-slide every 8 sec
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="hero-banner">
      <div className="hero-slides-wrapper">
        {heroSlides.map((slide, index) => (
          <div
            key={slide.id}
            className={`hero-slide ${index === current ? "active" : ""}`}
          >
            <img src={slide.image} alt={slide.title} className="hero-bg" />
            <div className="hero-overlay" />

            <div className="hero-content">
              <h1 className="hero-title">{slide.title}</h1>
              <p className="hero-subtitle">{slide.subtitle}</p>
              <div className="hero-buttons">
                <button className="hero-btn primary">Start Reading</button>
                <button className="hero-btn secondary">Details</button>
              </div>
            </div>
          </div>
        ))}
      </div>

        <button className="hero-carousel-arrow left" onClick={prevSlide}>
        <ChevronLeft size={28} strokeWidth={2.5} color="white" />
        </button>
        <button className="hero-carousel-arrow right" onClick={nextSlide}>
        <ChevronRight size={28} strokeWidth={2.5} color="white" />
        </button>      
        
        {/* Indicators */}
        <div className="carousel-indicators">
        {heroSlides.map((_, index) => (
          <span
            key={index}
            className={`dot ${index === current ? "active" : ""}`}
            onClick={() => setCurrent(index)}
            style={{ cursor: "pointer" }}
          ></span>
        ))}
      </div>
    </div>
  );
};

export default HeroCarousel;
